import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const shorten = (string) => {
  let truncStr = '';
  if (string.length > 15) {
    truncStr = `${string.substring(0, 10)}...`;
  } else {
    truncStr = string;
  }
  return truncStr;
}

const HistoryModal = (props) => {
  return (
    <div>
      <div className="modal historyModal">
        <div id="showHistory" onClick={props.showModal} className="exitModal">
          <FontAwesomeIcon icon="times" className="icon"/>
        </div>
        <h2>All songs</h2>
        <ul className="song-history-list">
          {props.songHistory.map((song, i) => {
            return (
              <li id={song.songId} onClick={props.changeActiveSong} className={song.songId === props.recommendedSongId ? 'song-option song-option-active' : 'song-option'}>
                <img src={song.albumImg} alt={song.albumName} className="albumImg" id={song.songId} onClick={props.changeActiveSong}/>
                <div>
                  <h3 id={song.songId} onClick={props.changeActiveSong}>{shorten(song.songName)}</h3>
                  <p className="artistName" id={song.songId} onClick={props.changeActiveSong}>{song.artistNames.map((artist, i) => {
                    return <span>{artist}{((i + 1) < song.artistNames.length) && ", "}</span>
                  })}</p>
                  <p id={song.songId} onClick={props.changeActiveSong}><span className="albumName" id={song.songId} onClick={props.changeActiveSong}>{shorten(song.albumName)}</span> <span className="albumYear" id={song.songId} onClick={props.changeActiveSong}>({song.albumYear})</span></p>
                  <a href={song.externalURL} target="_blank" rel="noopener noreferrer" className="spotify-link"><FontAwesomeIcon icon={['fab', 'spotify']} className="icon" /></a>
                </div>
              </li>
            )
          })}
        </ul>
        </div>
      <div className="modalBackground"></div>
    </div>
  )
}

export default HistoryModal;